import { Routes } from '@angular/router';
import { authGuard } from './guards/auth.guard';
import { passwordExpiredGuard } from './guards/password-expired.guard';

export const routes: Routes = [
  { path: '', redirectTo: '/dashboard/study/list', pathMatch: 'full' },
  {
    path: 'auth-callback',
    loadComponent: () => import('./pages/auth-callback/auth-callback.component').then(m => m.AuthCallbackComponent),
    canActivate: [authGuard],
  },
  {
    path: 'login-callback',
    loadComponent: () => import('./pages/login-callback/login-callback.component').then(m => m.LoginCallbackComponent),
  },
  {
    path: 'auth/invitation/:token',
    loadComponent: () => import('./pages/invitation/invitation.component').then(m => m.InvitationComponent),
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./layout/layout.routes').then(m => m.LAYOUT_ROUTES),
    canActivate: [authGuard],
  },
  {
    path: 'password-expired',
    loadComponent: () => import('./pages/password-expired/password-expired.component').then(m => m.PasswordExpiredComponent),
    canActivate: [passwordExpiredGuard],
  },
  {
    path: 'forbidden',
    loadComponent: () => import('./pages/forbidden/forbidden.component').then(m => m.ForbiddenComponent),
  },
  {
    path: '**',
    loadComponent: () => import('./pages/page-not-found/page-not-found.component').then(m => m.PageNotFoundComponent),
  },
];
